import { faMagnifyingGlass, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React,{useState} from "react";

function GameSearchBar({ handleSubmit, scButton, handleChange, clearSearch, search }) {
  const pathSegments = window.location.pathname.split("/");
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  return (
    <div
      className={`xl:w-3/5 lg:w-1/2  md:w-full w-full -mt-9 items-center inline-flex
        ${isMobileView && pathSegments[1] === "chartSearch"
          ? ""
          : isMobileView && pathSegments[1] === "charts"
          ? ""
          : "justify-start px-5"}
      `}
    >
      <form onSubmit={handleSubmit} className= {isMobileView ? "w-full" : ""}>
        <input
          type="text"
          placeholder="Find League"
          value={search}
          onChange={handleChange}
          className={`border rounded-full text-sm w-full px-3 py-2 focus:outline-none focus:border-green-300 bg-slate-50 ${
            isMobileView ? "mt-4" : "md:w-[230px]"
          }`}
        />
      </form>
      <div>
        {!scButton && (
          <FontAwesomeIcon
            onClick={handleSubmit}
            className={
              isMobileView
                ? "-ml-7 mt-3 mb-1 text-slate-500"
                : "-ml-8 mb-2 mt-3"
            }
            icon={faMagnifyingGlass}
          />
        )}
      </div>

      {scButton && (
        <FontAwesomeIcon
          icon={faTimes}
          className={
            isMobileView
              ? "-ml-7 mt-4 cursor-pointer text-slate-500"
              : "ml-20 cursor-pointer text-slate-500"
          }
          onClick={clearSearch}
        />
      )}
    </div>
  );
}

export default GameSearchBar;
